<template>
  <div class="headNav flex-center">
    <div class="boxLeft site-title">
      <img :src="titleLogo" class="logo" alt="logo"/>
      <div class="logo-title">
        <svg xmlns="http://www.w3.org/2000/svg"
             font-family="PingFang SC, sans-serif" font-weight="600" height="35" viewBox="0 0 1000 52"
             style="paint-order:stroke;">
          <text x="15" y="42" fill="#29599C" stroke="#ffffff" stroke-width="4" font-size="38" letter-spacing="4"
                lengthAdjust="spacingAndGlyphs">
            {{ site.siteTitle }}
          </text>
        </svg>
      </div>
    </div>
    <div class="boxRight flex-between-center">
      <Link to="/index">
        <span class="title">首页</span>
      </Link>
      <Link to="/purchase/list?projectType=0&noticeType=0&dwtype=0&purchaseWay=0">
        <span class="title" :class="isPurchasePage ? 'active' : ''">公告公示</span>
      </Link>
      <!-- 内容栏目 -->
      <Link :to="'/info/' + item.children[0].id" v-for="(item,index) in infoMenu" :key="index">
        <span class="title" :class="currentChannelId == item.id && !isPurchasePage ? 'active' : ''">{{
            item.channelName
          }}</span>
      </Link>
      <!-- 关于我们 -->
      <Link :to="'/introduce/' + channel_gywm[0].children[0].id">
        <span class="title" :class="isAboutPage ? 'active' : ''">{{ channel_gywm[0].channelName }}</span>
      </Link>
    </div>
  </div>
</template>

<script>
import Link from './Link'
import {mapGetters} from 'vuex'
import titleLogo from "@/assets/imgs/title-logo.jpg"

export default {
  name: 'NavItem',
  components: {
    Link
  },
  props: {},
  data() {
    return {
      titleLogo: titleLogo
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['channel_gywm', 'site']),
    logo() {
      return this.site.baseUrl + this.site.logo[0].url
    },
    // 过滤 关于我们
    infoMenu() {
      return this.$store.getters.menus.filter(
          (menu) => menu.channelPath !== 'gywm'
      )
    },
    isPurchasePage() {
      return (
          this.$route.name === 'PurchaseList' ||
          this.$route.name === 'PurchaseDetail'
      )
    },
    isAboutPage() {
      return this.$route.name === 'Introduce'
    },
    //获取路由中栏目的id
    currentChannelId() {
      if (this.$store.getters.activeMenu.parentId) {
        return this.$store.getters.activeMenu.parentId
      } else {
        return this.$store.getters.activeMenu.id
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {},
}
</script>

<style lang="scss" scoped>
.headNav {
  width: 100%;
  height: 85px;
  background: #24539c;

  .boxLeft {
    width: 50%;
    height: 100%;
  }

  .boxRight {
    width: 50%;
    height: 100%;
    padding-right: 13%;

    .title {
      font-size: 18px;
      font-weight: 900;
      color: #ffffff;
    }

    .active {
      font-size: 22px;
      text-decoration: underline;
    }
  }
}

.site-title {
  display: flex;
  align-items: center;
  padding-left: 12.5%;
  .logo {
    width: auto;
    height: 35px;
  }

  .logo-title {
  }
}
</style>
